import React, { lazy } from 'react';
import { connect } from 'react-redux';
import { Switch, Route } from 'react-router-dom';
import {
  Loader, Container, Message,
} from 'semantic-ui-react';
import { withTranslation } from 'react-i18next';
import styled from 'styled-components';

import CompleteVerifyEmail from 'components/lib/Entry/CompleteVerifyEmail';
import IdeaPDF from 'components/ideas/IdeaPDF';
import { Footer, NavBar } from 'components/lib/UI';
import useTheme from 'theme/useTheme';

import SmartLink from 'components/entry/SmartLink';
import LoginError from 'components/entry/LoginError';
import LoginWithToken from 'components/entry/LoginWithToken';
import AuthoriseToken from 'components/entry/AuthoriseToken';
import PresentIdea from 'components/ideas/Present';
import Idea from 'components/ideas';
import Challenge from 'components/challenges/Challenge';

import UserSwitch from './UserSwitch';
import NonUserSwitch from './NonUserSwitch';

const Poll = lazy(() => import('components/polls/Poll'));
const MobileNewIdeaButton = lazy(() => import('components/lib/MobileNewIdeaButton'));

const StyledDashboard = styled.div`
  display: flex;
  min-height: 100vh;
  flex-direction: column;
`;
const StyledDashboardContent = styled.div`
  flex: 1 0 auto;
  position:relative;
  background-color: #f9f9f9;
  display:flex;
  flex-direction:column;
`;

const AppRouting = ({
  t, user, isGettingUser, gettingUserError, showLogin, ipBlocked,
}) => {
  const theme = useTheme();
  return (
    <Switch Switch>
      <Route path="/login/error" component={LoginError} />
      <Route path="/login/with" component={LoginWithToken} />
      <Route path="/start" component={SmartLink} />
      <Route path="/tokens/authorise" component={AuthoriseToken} />
      <Route path="/ideas/:id/present" component={PresentIdea} />
      <Route path="/verify-email" component={CompleteVerifyEmail} />
      <Route path="/polls/:id" component={Poll} />
      <Route path="/challenges/:id/share" render={() => <Container style={{ marginTop: 40 }}><Challenge /></Container>} />
      <Route path="/ideas/:id/pdf" component={IdeaPDF} />
      <Route path="/ideas/:id/share" render={() => <Container style={{ marginTop: 40 }}><Idea /></Container>} />
      <Route render={() => (
        <React.Fragment>
          {(isGettingUser)
            ? <Loader active inline="centered" style={{ marginTop: 30 }} />
            : (
              <StyledDashboard>
                <NavBar />
                <StyledDashboardContent>
                  {ipBlocked
                    ? (
                      <Container style={{ marginTop: 20 }}>
                        <Message>
                          <p><strong>Access denied</strong></p>
                          <p>The network or location you are trying to access SimplyDo from is not permitted in your account's security settings. Please reach out to an administrator in your organisation for assistance.</p>
                        </Message>
                      </Container>
                    )
                    : (
                      <>
                        {user && <UserSwitch />}
                        <NonUserSwitch />
                        {(gettingUserError && !showLogin)
                          ? (
                            <Container style={{ marginTop: 20 }}>
                              <Message>
                                <p><strong>{t('main.problemLoading')}</strong></p>
                                <p>{gettingUserError}</p>
                              </Message>
                            </Container>
                          ) : null
                    }
                        {theme.sizes.isMobile && user && <MobileNewIdeaButton />}
                      </>
                    )
                }
                </StyledDashboardContent>
                <Footer />
              </StyledDashboard>
            )
          }
        </React.Fragment>
      )}
      />
    </Switch>
  );
};

const mapStateToProps = ({ user, auth }) => ({
  user, showLogin: auth.showLogin, isGettingUser: auth.isGettingUser, gettingUserError: auth.errorMessage, ipBlocked: auth.ipBlocked,
});

export default connect(mapStateToProps)(withTranslation()(AppRouting));
